import { frontendURL } from '../../../helper/URLHelper';
import DealsIndex from './pages/DealsIndex.vue';
import TasksIndex from './pages/TasksIndex.vue';
import DealDetailView from './pages/DealDetailView.vue';
import TaskDetailView from './pages/TaskDetailView.vue';
import QuotesIndex from './pages/QuotesIndex.vue';
import QuoteDetailView from './pages/QuoteDetailView.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent'],
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm/deals'),
    component: DealsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_deals_index',
        component: DealsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/crm/deals/:dealId'),
    component: DealDetailView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_deal_show',
        component: DealDetailView,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/crm/tasks'),
    component: TasksIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_tasks_index',
        component: TasksIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/crm/tasks/:taskId'),
    component: TaskDetailView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_task_show',
        component: TaskDetailView,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/crm/quotes'),
    component: QuotesIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_quotes_index',
        component: QuotesIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/crm/quotes/:quoteId'),
    component: QuoteDetailView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'crm_quote_show',
        component: QuoteDetailView,
        meta: commonMeta,
      },
    ],
  },
];
